import { serviceNetworkError } from "../failhandler";

var salesMaterial = (function () {
	"use scrict";
	
    var salesMaterialContainer = $('.sales-material-container');

	if(salesMaterialContainer.length > 0) {

	var count = 0,
		campaignPickerBtn = $('.campaign-picker'),
		sendBtn = $('#sendCampaigns'),
		responseWrap = salesMaterialContainer.find('.response-wrapper'),
		errorMessage = responseWrap.attr('data-error-message'),
		cl = new CanvasLoader('loader'),
		countCampaigns = 0,
		countText = $('.countText'),
		article = countText.attr('data-text'),
		articles = countText.attr('data-texts'),
		successMessage = sendBtn.attr('data-success-message');

		cl.setDiameter(20);
		cl.setDensity(17);
		cl.setRange(1.1);
		cl.setSpeed(1);
		cl.setColor('#ffffff');
		cl.setFPS(24);

		campaignPickerBtn.on('click', function() {

			var $this = $(this);
			
			if(!$this.hasClass('activeCampaign')) {
				$this.closest('.three-col').find('.activeCampaign').removeClass('activeCampaign');
				$this.addClass('activeCampaign');
			}
			else {
				$this.closest('.three-col').find('.activeCampaign').removeClass('activeCampaign');
			}

			countCampaigns = $('.activeCampaign').length;

			$('.countCampaigns').find('.count').html(countCampaigns);

			if(countCampaigns > 0) {
				if(countCampaigns === 1) {
					countText.html(article);
				}
				else {
					countText.html(articles);
				}
				sendBtn.parent().removeClass('hidden');
				responseWrap.hide();

			}
			else {
				sendBtn.parent().addClass('hidden');
			}
			
			return false;

		});

		sendBtn.on('click', function(e) {

		    e.preventDefault();

		    var choosenArticles = new Array();

		    $(".campaign-picker.activeCampaign").each(function () {
		        var articleData = {
		            articlenumber: $(this).data("articleid"),
		            round: $(this).data("round")
		        };

		        choosenArticles.push(articleData);
		    });		    

		    var data = {
                articles: choosenArticles
		    };

			sendBtn.addClass('loading');
			cl.show();
			responseWrap.hide();

			var ajaxRequest = $.ajax({
				url: SETTINGS.services.admin.methods.postSalesMateriel,
				data: JSON.stringify({ 'request': data })
			});
			
			ajaxRequest.done(doneHandler);
			ajaxRequest.fail(failHandler);						
		});

		function doneHandler(response) {

			if(countCampaigns) {

				if(response.Success) {
					
					sendBtn.removeClass('loading');					
					salesMaterialContainer.find('.activeCampaign').trigger('click');
					responseWrap.html(successMessage).show();
				}
				else {

				    sendBtn.removeClass('loading');
                    
				    responseWrap.show().html('<p>' + successMessage + '</p><ul class="error-list"></ul>');

				    for (var i = 0; i < response.Data.length; i++) {
				        var articleNumber = response.Data[i].ArticleNumber,
				            roundId = response.Data[i].RoundId,
                            orderSuccess = response.Data[i].OrderSuccess;

				        if (!orderSuccess) {
				            $('.campaign-picker.activeCampaign').each(function () {

				                if ($(this).attr('data-articleid') === articleNumber && $(this).attr('data-round') === roundId) {
				                    var campaign = $(this).closest('.sales-material').children('h3').text();
				                    var selected = $(this).closest('.sales-material').find('.activeCampaign').next('h5').text();

				                    responseWrap.find('ul').append('<li>' + errorMessage + ' ' + campaign + ' - ' + selected + '</li>');
				                }

				            });
				        }
				    }
				}

				cl.hide();
			}
			else {
				sendBtn.parent().addClass('hidden');
			}
			
		}

		function failHandler() {
		    serviceNetworkError(responseWrap);
		}
	}

})();